<template>
  <div class="Navigation">
    <button class="Navigation__burger-wrapper" :class="[{ 'is-active': $route.meta.name != 'chapters' }]" @click="onClick">
			<span class="Navigation__burger" />
		</button>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  methods: {
    onClick() {
      const menu = this.$root.orientation == 'portrait' ? 'menu.' + this.lang : 'about.' + this.lang
      this.$router.push({
        name: this.$route.meta.name == 'chapters' ? menu : 'chapters.' + this.lang,
        params: this.$route.params
      })
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'
@import './styl/Hamburger-icon'

.Navigation
  position fixed
  top 0px
  left 0px
  right 0px
  z-index 999

  &__burger
    hamburger-generator(25px, 2px, 5px, white, $timing-function: linear)

  &__burger-wrapper
    position fixed
    cursor pointer
    right 15px
    top 15px
    z-index 999
    padding 0px
    z-index 99999999999
    padding 10px
    &.is-active
      .Navigation__burger
        hamburger-animation()

</style>
